module.exports = __webpack_public_path__ + "img/device_b.35107bd9.svg";